import axios from "./axios.interceptors";

export interface FlightFinancialReport {
  flightId: string;
  flightNumber: string;
  route: string;
  departureDateTime: string;
  arrivalDateTime: string;
  totalSeats: number;
  occupiedSeats: number;
  emptySeats: number;
  noShowSeats: number;
  brutFlightTotal: number;
  refundableTaxes: number;
  netTotal: number;
  averagePerTraveler: number;
  averagePerSeat: number;
  totalAirportTax: number;
  currencyCode: string;
}

class FinancialReportsService {
  async getFlightReport(flightId: string): Promise<FlightFinancialReport> {
    const response = await axios.get(
      `/api/admin/financial-reports/flights/${flightId}`
    );
    return response.data;
  }
}

export default new FinancialReportsService();
